//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emailjs from 'emailjs-com'
export default {
    data() {
        return {
            form: {
                name: '',
                restaurantName: '',
                email: '',
                phone: '',
            },
            displayLoading: false,
            displayAlert: false,
            alertTitle: '',
            alertMessage: '',
            alertType: '',
        }
    },
    methods: {
        logEntry(section, action) {
            this.$analytics.logEvent('Landing Action', {
                content_section: section,
                content_action: action,
            })
        },
        sendEmail() {
            if (
                this.form.name === '' ||
                this.form.restaurantName === '' ||
                this.form.email === '' ||
                this.form.phone === ''
            ) {
                this.displayLoading = false
                this.alertTitle = 'Error'
                this.alertMessage =
                    'Por favor asegurate de llenar todos los campos'
                this.alertType = 'error'
                this.displayAlert = true
                return
            } else {
                this.displayLoading = true
                emailjs
                    .send(
                        'gmail',
                        'template_Nldne3t8',
                        this.form,
                        'user_l9KYZVj8DNvwXi3kegar5'
                    )
                    .then(
                        result => {
                            this.logEntry('email', 'sendEmail')
                            this.displayLoading = false
                            this.alertTitle = 'Exito!'
                            this.alertMessage =
                                'Tu mensaje ha sido enviado con exito, pronto nos estaremos poniendo en contacto contigo'
                            this.alertType = 'success'
                            this.displayAlert = true
                            this.form.name = ''
                            this.form.email = ''
                            this.form.phone = ''
                            this.form.restaurantName = ''
                        },
                        error => {
                            this.displayLoading = false
                            this.alertTitle = 'Error'
                            this.alertMessage =
                                'Hubo un error por favor intentarlo nuevamente.'
                            this.alertType = 'error'
                            this.displayAlert = true
                        }
                    )
            }
        },
    },
    mounted() {
        window.scrollTo(0, 0)
        if (
            this.$route.fullPath == '/' ||
            this.$route.fullPath.includes('/#')
        ) {
            var element = document.createElement('link')
            element.setAttribute('rel', 'stylesheet')
            element.setAttribute('type', 'text/css')
            element.setAttribute(
                'href',
                'https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css'
            )
            document.getElementsByTagName('head')[0].appendChild(element)
        }
    },
}
